import { useState } from "react";
import { useTranslation } from "react-i18next";

import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";

import TkPopProductDetailCommonDialog from "../dialogTypes/TkPopProductDetailCommonDialog";
import { useEffect } from "react";
import getSchema from "../../lib/api/getSchema";
import { settingHideProcessShcema } from "../../lib/TkPopUtils/TkPopProductMangeDetailUtils";

function TkPopProductManageDetailCAMButton(props) {

    const { t } = useTranslation();
    const id = "CAM"
    const { schema, refresh, onSuccess, onSelectMst, createButtonName, customizeErrorMsgCallback, ...others } = props;

    const [open, setOpen] = useState(false);

    const [shcemaPerProcess, setShcemaPerProcess] = useState();

    useEffect(() => {

        let mounted = true;

        (async () => {

            let schema = await getSchema("TkPopProductManageDetail");

            if (mounted) {


                schema = settingHideProcessShcema("CAM", schema);

                schema.columns.push({
                    name: "workers",
                    formOrder: 315,
                    hideInForm: false,
                    formGroup: 0,
                    formItemType: "multipleAutocomplete",

                    codeInfo: {
                        tableName: "User",
                        nameColumn: ["fullName"],
                        valueColumn: "username",
                        useEmptyValue: false,
                        sortByName: true,
                    }
                })

                setShcemaPerProcess(schema);

            }

        })();

        return (() => {

            mounted = false;

        });

    }, []);

    const onOpen = () => {

        setOpen(true);

    };

    const onClose = () => {

        setOpen(false);

    };

    const onCreateSuccess = (msg) => {

        if (onSuccess) {

            onSuccess(msg);

        }

        refresh.refresh();

    };


    return (

        <>
            <CreateRecordButtonLayout id={id + "create-button"} onClick={onOpen} createButtonName={createButtonName} {...others} />
            <TkPopProductDetailCommonDialog
                id={id + "create-dialog"}
                mode="update"
                formId={id + "create-form"}
                title={shcemaPerProcess ? t(`dialog.title.CAM.create`) : ""}
                schema={shcemaPerProcess}
                initialData={undefined}
                open={open}
                processCode={id}
                onClose={onClose}
                onSelectMst={onSelectMst}
                onSuccess={onCreateSuccess}
                customizeErrorMsgCallback={customizeErrorMsgCallback}
            />
        </>

    );
}

export default TkPopProductManageDetailCAMButton;

